import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ContactSearchPipe' })
export class ContactSearchPipe implements PipeTransform {
  /**
   * Pipe filters the list of elements based on the search text provided
   *
   * @param items list of elements to search in
   * @param searchText search string
   * @returns list of elements filtered by search text or []
   */
  transform(items: any[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    return items.filter(it => {
      console.log(it.contacts[0].first_name+"|"+it.contacts[0].first_name+"|"+it.contacts[0].business_name);
      return (it.contacts[0].first_name.toLocaleLowerCase().includes(searchText) || it.contacts[0].last_name.toLocaleLowerCase().includes(searchText) || it.contacts[0].business_name.toLocaleLowerCase().includes(searchText) );
    });
  }
}